import { useState, useEffect } from "react";
import { Hub, Auth } from "aws-amplify";

/**
 *
 * @returns {boolean | null}
 */

export default function AuthenticatedStatus() {
	const [isAuthenticated, setIsAuthenticated] = useState(null);

	async function ionViewCanEnter() {
		try {
			const authenticatedUser = await Auth.currentAuthenticatedUser();
			if (authenticatedUser !== undefined) {
				setIsAuthenticated(true);
			} else {
				setIsAuthenticated(false);
			}
		} catch (error) {
			setIsAuthenticated(false);
		}
	}

	useEffect(() => {
		ionViewCanEnter();
	});

	useEffect(() => {
		const listener = (data) => {
			// eslint-disable-next-line default-case
			switch (data.payload.event) {
				case "signIn" || "autoSignIn" || "tokenRefresh":
					setIsAuthenticated(true);
					break;
				case "signOut" ||
					"signIn_failure" ||
					"tokenRefresh_failure" ||
					"autoSignIn_failure":
					setIsAuthenticated(false);
					break;
			}
		};

		const unsubscribe = Hub.listen("auth", listener);

		return () => {
			unsubscribe();
		};
	});

	return isAuthenticated;
}
